import { render } from "./Scientists.vue?vue&type=template&id=673a733a&scoped=true"
import script from "./Scientists.vue?vue&type=script&lang=js"
export * from "./Scientists.vue?vue&type=script&lang=js"

import "./Scientists.vue?vue&type=style&index=0&id=673a733a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-673a733a"]])

export default __exports__